module.exports = __webpack_public_path__ + "img/节点安全.afe67330.png";